<template>
  <div class="accommodation-container">
    <v-layout row wrap>
      <v-flex align-content-space-between
              md4
              xs12
              v-if="paymentTrue !== undefined && paymentTrue !== null && paymentTrue.length > 0"
              v-for="accomodation in paymentTrue"
              :key="accomodation.public_id">
        <v-container fluid class="pa-2">
          <v-card flat hover class="accommodation-card elevation-2">
            <!-- Image section - clickable to open info -->
            <div @click="openInfo(accomodation)" style="cursor: pointer;">
              <v-img class="accommodation-image"
                     :src="accomodation.thumbnail"
                     aspect-ratio="1.5"
                     gradient="to bottom, rgba(0,0,0,0.1), rgba(0,0,0,0.3)">
                <v-container fill-height class="pa-0">
                  <v-layout align-end class="image-overlay">
                    <v-flex xs12>
                      <span class="accommodation-badge" v-if="accomodation.pricing_status === 'true'">
                        <template v-if="accomodation.accomodation_type_id === 'Stables'">
                          {{$localCurrency}} {{$roundOff(convert1(accomodation.price[0].currency_type, accomodation.price[0].mandatory_price).amount)}}
                        </template>
                        <template v-else>
                          From {{$localCurrency}} {{$roundOff(convert1(accomodation.price[0].currency_type, accomodation.price[0].price).amount)}}
                        </template>
                      </span>
                    </v-flex>
                  </v-layout>
                </v-container>
              </v-img>
            </div>

            <v-container fluid class="pt-3 pb-0">
              <!-- Title section - clickable to open info -->
              <div @click="openInfo(accomodation)" style="cursor: pointer; display: inline-block;">
                <h3 class="accommodation-title earthwerk-font">{{(accomodation.name).toUpperCase()}}</h3>
              </div>

              <!-- Info icon -->
              <v-icon small @click="openInfo(accomodation)" class="info-icon">info_outline</v-icon>

              <div class="accommodation-details mt-2">
                <span v-if="accomodation.pricing_status === 'true'">
                  <div v-if="accomodation.accomodation_type_id === 'Stables'" class="price-info">
                    Price: {{$localCurrency}} {{$roundOff(convert1(accomodation.price[0].currency_type, accomodation.price[0].mandatory_price).amount)}}
                  </div>
                  <div v-else class="price-info">
                    <div v-for="(price, key) in developPricePacks(accomodation)" :key="key" class="price-pack">
                      <span>From <b>{{price.lower_limit}}</b> to <b>{{price.upper_limit}}</b>: </span>
                      <span>{{$localCurrency}} {{$roundOff(convert1(price.currency, price.price).amount)}}</span>
                    </div>
                  </div>
                </span>
              </div>
            </v-container>
          </v-card>
        </v-container>
      </v-flex>
    </v-layout>

    <v-layout row wrap v-if="paymentTrue === undefined || paymentTrue === null || paymentTrue.length === 0">
      <v-flex lg4 md12 xs12 sm12 v-for="n in 3" :key="n">
        <v-container fluid class="pa-2">
          <v-card class="elevation-2">
            <v-container>
              <content-placeholders :rounded="true">
                <content-placeholders-img />
                <content-placeholders-heading />
              </content-placeholders>
            </v-container>
          </v-card>
        </v-container>
      </v-flex>
    </v-layout>

    <!-- Info Dialog -->
    <v-dialog v-model="infoDialog" persistent max-width="900px">
      <v-card class="info-dialog">
        <div class="gallery-section">
          <div v-if="infoImages && infoImages.length > 0" class="gallery-container">
            <div class="image-navigation">
              <button class="nav-button prev" @click="prevInfoImage" :disabled="currentInfoImageIndex === 0">
                <v-icon>chevron_left</v-icon>
              </button>
              <div class="image-wrapper">
                <img :src="infoImages[currentInfoImageIndex].path" class="gallery-image" alt="Facility image">
              </div>
              <button class="nav-button next" @click="nextInfoImage" :disabled="currentInfoImageIndex === infoImages.length - 1">
                <v-icon>chevron_right</v-icon>
              </button>
            </div>
            <div class="image-counter">
              {{ currentInfoImageIndex + 1 }} / {{ infoImages.length }}
            </div>
          </div>
          <div v-else class="single-image-container">
            <img :src="currentInfoAccommodation ? currentInfoAccommodation.thumbnail : ''" class="gallery-image" alt="Facility thumbnail">
          </div>
        </div>
        
        <v-card-text class="details-section">
          <div class="details-header">
            <h1 class="facility-title earthwerk-font">{{ currentInfoAccommodation ? currentInfoAccommodation.name.toUpperCase() : '' }}</h1>
            <div class="capacity-display">
              <div class="capacity-item">
                <v-icon small color="grey">people</v-icon>
                <span class="capacity-label">Maximum Capacity:</span>
                <span class="capacity-value">{{ currentInfoAccommodation ? currentInfoAccommodation.maximum_guests : '' }} Guests</span>
              </div>
              <div class="capacity-item" v-if="currentInfoAccommodation && currentInfoAccommodation.quantity">
                <v-icon small color="grey">hotel</v-icon>
                <span class="capacity-label">Available Rooms:</span>
                <span class="capacity-value">{{ currentInfoAccommodation.quantity }}</span>
              </div>
            </div>
          </div>
          <div class="description-section" v-html="currentInfoAccommodation ? currentInfoAccommodation.description : ''"></div>
          
          <!-- Pricing information in dialog -->
          <div v-if="currentInfoAccommodation && currentInfoAccommodation.pricing_status === 'true'" class="pricing-section">
            <h3 class="earthwerk-font">Pricing Information</h3>
            <div v-if="currentInfoAccommodation.accomodation_type_id === 'Stables'" class="price-info-dialog">
              <div class="price-pack">
                <span>Price: </span>
                <span>{{$localCurrency}} {{$roundOff(convert1(currentInfoAccommodation.price[0].currency_type, currentInfoAccommodation.price[0].mandatory_price).amount)}}</span>
              </div>
            </div>
            <div v-else class="price-info-dialog">
              <div v-for="(price, key) in developPricePacks(currentInfoAccommodation)" :key="key" class="price-pack">
                <span>From <b>{{price.lower_limit}}</b> to <b>{{price.upper_limit}}</b> guests: </span>
                <span>{{$localCurrency}} {{$roundOff(convert1(price.currency, price.price).amount)}} per night</span>
              </div>
            </div>
          </div>
        </v-card-text>
        
        <v-card-actions class="dialog-actions">
          <v-spacer></v-spacer>
          <v-btn flat @click="infoDialog = false" class="earthwerk-font">Close</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
  export default {
    name: 'Accomodations',
    data() {
      return {
        infoDialog: false,
        currentInfoAccommodation: null,
        currentInfoImageIndex: 0,
        infoImages: []
      }
    },
    created() {
      this.$store.dispatch('get_active_accommodation')
    },
    methods: {
      openInfo(accommodation) {
        this.currentInfoAccommodation = accommodation
        this.currentInfoImageIndex = 0
        this.infoDialog = true
        
        // Fetch facility images if available
        if (this.$store.dispatch && this.$store._actions && this.$store._actions['get_facility_images']) {
          this.$store.dispatch('get_facility_images', accommodation.public_id).then(() => {
            if (this.$store.state.FacilityStore && this.$store.state.FacilityStore.facility_images) {
              this.infoImages = this.$store.state.FacilityStore.facility_images
            }
          }).catch(() => {
            this.infoImages = []
          })
        }
      },
      
      prevInfoImage() {
        if (this.currentInfoImageIndex > 0) {
          this.currentInfoImageIndex--
        }
      },
      
      nextInfoImage() {
        if (this.currentInfoImageIndex < this.infoImages.length - 1) {
          this.currentInfoImageIndex++
        }
      },
      
      getAccomodationUrl: function (image) {
        return '@/assets/images/accomodation/accomodation' + image + '.jpg'
      },
      
      facilityImage: function (image) {
        return 'http://178.79.164.219:8000/var/www/html/opc_services/' + image
      }
    },
    computed: {
      paymentTrue: function () {
        var activeInventory = []
        if (this.allAccommodations && Array.isArray(this.allAccommodations)) {
          this.allAccommodations.map(function (data) {
            if (data.pricing_status === 'true' && data.thumbnail !== null) {
              activeInventory.push(data)
            }
          })
        }
        return activeInventory
      }
    }
  }
</script>

<style scoped>
  @font-face {
    font-family: 'Earthwerk';
    src: url('../PizzaDude.dk-Earthwerk.otf');
    font-weight: normal;
    font-style: normal;
  }

  .accommodation-container {
    max-width: 1200px;
    margin: 0 auto;
    position: relative;
  }

  .accommodation-card {
    border-radius: 8px !important;
    transition: all 0.3s ease;
    overflow: hidden;
  }

  .accommodation-card:hover {
    transform: translateY(-5px);
    box-shadow: 0 10px 20px rgba(0,0,0,0.1) !important;
  }

  .accommodation-image {
    border-radius: 8px 8px 0 0 !important;
    transition: transform 0.5s ease;
    overflow: hidden;
  }

  .accommodation-card:hover .accommodation-image {
    transform: scale(1.05);
  }

  .image-overlay {
    padding: 16px;
  }

  .accommodation-badge {
    background-color: rgba(116, 165, 51, 0.9);
    color: white;
    padding: 4px 12px;
    border-radius: 16px;
    font-size: 14px;
    font-weight: 600;
    display: inline-block;
  }

  .earthwerk-font {
    font-family: 'Earthwerk', sans-serif;
    color: #333;
    font-size: 20px;
    line-height: 1.3;
    margin-bottom: 8px;
    letter-spacing: 0.5px;
  }

  .accommodation-title {
    transition: color 0.2s ease;
    display: inline-block;
  }

  .accommodation-title:hover {
    color: #74a533 !important;
  }

  .info-icon {
    cursor: pointer;
    color: #666;
    margin-left: 10px;
    vertical-align: middle;
    transition: color 0.2s ease;
  }

  .info-icon:hover {
    color: #74a533;
  }

  .price-info {
    color: #666;
    font-size: 14px;
  }

  .price-pack {
    margin-bottom: 6px;
  }

  .price-pack span:last-child {
    color: #e67e22;
    font-weight: 600;
  }

  .accommodation-details {
    border-top: 1px solid #eee;
    padding-top: 12px;
  }

  /* Info Dialog Styles */
  .info-dialog {
    border-radius: 12px !important;
    overflow: hidden;
  }

  .gallery-section {
    width: 100%;
    border-radius: 12px;
    overflow: hidden;
    box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);
    position: relative;
  }

  .gallery-container, .single-image-container {
    width: 100%;
    height: 400px;
  }

  .image-navigation {
    display: flex;
    align-items: center;
    justify-content: space-between;
    height: 100%;
    position: relative;
  }

  .image-wrapper {
    width: 100%;
    height: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
  }

  .gallery-image {
    width: 100%;
    height: 100%;
    object-fit: cover;
    display: block;
  }

  .nav-button {
    position: absolute;
    top: 50%;
    transform: translateY(-50%);
    background: rgba(255, 255, 255, 0.7);
    border: none;
    border-radius: 50%;
    width: 50px;
    height: 50px;
    display: flex;
    align-items: center;
    justify-content: center;
    cursor: pointer;
    z-index: 10;
    transition: all 0.3s ease;
  }

  .nav-button:hover {
    background: rgba(255, 255, 255, 0.9);
  }

  .nav-button:disabled {
    opacity: 0.5;
    cursor: not-allowed;
  }

  .nav-button.prev {
    left: 20px;
  }

  .nav-button.next {
    right: 20px;
  }

  .image-counter {
    position: absolute;
    bottom: 20px;
    left: 50%;
    transform: translateX(-50%);
    background: rgba(0, 0, 0, 0.6);
    color: white;
    padding: 5px 15px;
    border-radius: 20px;
    font-size: 14px;
    z-index: 10;
  }

  .details-section {
    background: white;
    border-radius: 12px;
    padding: 30px;
    box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);
  }

  .details-header {
    margin-bottom: 25px;
    border-bottom: 1px solid #eee;
    padding-bottom: 20px;
  }

  .facility-title {
    font-family: 'Earthwerk', sans-serif;
    color: #333;
    font-size: 32px;
    margin-bottom: 15px;
    letter-spacing: 0.5px;
  }

  .description-section {
    color: #555;
    line-height: 1.8;
    font-size: 16px;
    margin-bottom: 30px;
  }

  .capacity-display {
    display: flex;
    gap: 20px;
    margin-top: 15px;
    flex-wrap: wrap;
  }

  .capacity-item {
    display: flex;
    align-items: center;
    gap: 8px;
  }

  .capacity-label {
    font-size: 14px;
    color: #666;
  }

  .capacity-value {
    font-size: 16px;
    font-weight: 600;
    color: #74a533;
  }

  .pricing-section {
    margin-top: 20px;
    padding-top: 20px;
    border-top: 1px solid #eee;
  }

  .pricing-section h3 {
    margin-bottom: 15px;
    color: #74a533;
  }

  .price-info-dialog {
    color: #666;
    font-size: 16px;
  }

  .price-info-dialog .price-pack {
    margin-bottom: 10px;
  }

  .dialog-actions {
    padding: 16px 24px;
    border-top: 1px solid #eee;
  }

  /* Responsive adjustments */
  @media (max-width: 960px) {
    .earthwerk-font {
      font-size: 18px;
    }

    .gallery-container, .single-image-container {
      height: 300px;
    }

    .facility-title {
      font-size: 28px;
    }
  }

  @media (max-width: 600px) {
    .accommodation-card {
      margin-bottom: 16px;
    }

    .earthwerk-font {
      font-size: 16px;
    }

    .gallery-container, .single-image-container {
      height: 250px;
    }

    .facility-title {
      font-size: 24px;
    }

    .nav-button {
      width: 35px;
      height: 35px;
    }

    .nav-button.prev {
      left: 10px;
    }

    .nav-button.next {
      right: 10px;
    }

    .image-counter {
      font-size: 12px;
      padding: 3px 10px;
    }

    .capacity-display {
      flex-direction: column;
      gap: 10px;
    }
  }
</style>